import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Highlighter from '../highlighter';
import Link from '../link/internal-link';
import withTranslate from '../../hoc/with-translate';
import styles from './post-title.scss';

const renderTitle = (title, to, Link) => {
  return to ? (
    <Link to={to} className={classNames('forum-text-color', 'forum-link-hover-color')}>
      {title}
    </Link>
  ) : (
    <span>{title}</span>
  );
};

const renderCategoryLink = (category, Link, t) => {
  const to = `/${category.slug}`;
  return (
    <div className={classNames(styles.category, styles.link)}>
      {t('post-list-item.title-in-category')}&nbsp;
      <Link to={to} className={classNames('forum-text-color', 'forum-link-hover-color')}>
        <span className={styles.categoryLink}>{category.label}</span>
      </Link>
    </div>
  );
};

const PostTitle = ({
  title,
  type,
  query,
  className,
  to,
  component: Component,
  category,
  t,
  showCategoryLink,
}) => {
  const containerClassName = classNames(styles.title, styles[type], className, 'post-title');
  const linkClass = type === PostTitle.SINGLE ? '' : styles.link;
  return (
    <Component className={containerClassName} data-hook="post-title" tabIndex="0">
      <div className={linkClass}>
        {renderTitle(query ? <Highlighter text={title} query={query} /> : title, to, Link)}
      </div>
      {showCategoryLink && renderCategoryLink(category, Link, t)}
    </Component>
  );
};

PostTitle.SMALL = 'small';
PostTitle.MEDIUM = 'medium';
PostTitle.LARGE = 'large';
PostTitle.SINGLE = 'single';
PostTitle.SEARCH = 'search';
PostTitle.MEMBERS_AREA = 'membersArea';

PostTitle.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  query: PropTypes.string,
  className: PropTypes.string,
  to: PropTypes.string,
  component: PropTypes.any,
  category: PropTypes.object,
  t: PropTypes.func,
  showCategoryLink: PropTypes.bool,
};

PostTitle.defaultProps = {
  component: 'h2',
  showCategoryLink: false,
};

export default flowRight(withTranslate)(PostTitle);
